import { render, staticRenderFns } from "./SavedModal.vue?vue&type=template&id=7fa11e1d&scoped=true"
import script from "./SavedModal.vue?vue&type=script&lang=js"
export * from "./SavedModal.vue?vue&type=script&lang=js"
import style0 from "./SavedModal.vue?vue&type=style&index=0&id=7fa11e1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa11e1d",
  null
  
)

export default component.exports